module.exports = __webpack_public_path__ + "static/img/qq.4d46a834.png";